import { SwxTheme } from 'swx-atomic-component-lib'
const textFieldStyle = `
  color: ${SwxTheme.palette.black} !important;
  background-color: ${SwxTheme.palette.white};
  ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${SwxTheme.palette['secondary-mid']};
    opacity: 1; /* Firefox */
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: ${SwxTheme.palette['secondary-mid']} !important;
  }
  ::-ms-input-placeholder { /* Microsoft Edge */
    color: ${SwxTheme.palette['secondary-mid']};
  }
`

const commonTextFieldWrapperStyle = `
  width: 100%;
`

const iconRowStyle = `
  padding-top: 14px;
`

const formRowStyle = `
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  margin-bottom: 24px;
`

// This is for calcite icon
const iconStyle = {
  marginRight: '27px'
}

export {
  textFieldStyle,
  commonTextFieldWrapperStyle,
  iconRowStyle,
  formRowStyle,
  iconStyle
}
